import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

import { Business } from './businessSlice.types'

interface BusinessState {
  businesses: Business[]
}

const initialState: BusinessState = {
  businesses: [],
}

const businessSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    setBusinesses: (state, action: PayloadAction<Business[]>) => {
      state.businesses = action.payload
    },
    addBusiness: (state, action: PayloadAction<Business>) => {
      if (!state.businesses.find((b) => b.id === action.payload.id)) {
        state.businesses.push(action.payload)
      }
    },
  },
})

export const { setBusinesses, addBusiness } = businessSlice.actions

export const selectBusinesses = (state: RootState) => state.business.businesses

export default businessSlice.reducer
